module.exports = __webpack_public_path__ + "static/IMG_4231-e4c7dd11efb6ced2dd9bcb3a385150e0.jpeg";